/* ============================================================
   THE CUPCAKE COMPANY — Custom Scripts
   ------------------------------------------------------------
   Small site-wide behavioral fixes. Loaded from layout/theme.liquid.
   ============================================================ */

(function () {
  'use strict';

  /* ── Mega-menu placeholder-link fix (2026-04-24) ─────────────
     Top-level nav items like "Shop Locally" are placeholder links
     with href="#". When clicked they (a) append "#" to the URL,
     and (b) put DOM focus on the link. The theme's CSS keeps the
     mega menu open while `.menu-item-has-children:focus-within`
     is active (for keyboard accessibility), so the menu sticks
     open until the user clicks somewhere else to clear focus.

     Fix: intercept clicks on a[href="#"] inside the desktop mega
     menu. preventDefault stops the URL mutation, and blur removes
     focus immediately so the :focus-within rule stops matching
     and the menu closes naturally when the mouse leaves.

     Keyboard navigation still works: Tab still focuses the link
     (no click event fires) and opens the menu via :focus-within.
     ──────────────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest
      ? e.target.closest('.thb-full-menu li.menu-item-has-children > a[href="#"], .thb-full-menu li.menu-item-has-megamenu > a[href="#"]')
      : null;
    if (!link) return;
    e.preventDefault();
    if (typeof link.blur === 'function') link.blur();
  }, false);

  /* ── Product-modifier required validation (2026-04-27) ───────
     `snippets/product-modifiers.liquid` may render a `<fieldset
     class="product-modifiers" data-modifier-required="true">`
     above the Add-to-Cart button. For required modifier groups
     (Baby Shower Color, Happy Birthday Style), block form submit
     until a selection is made. The HTML5 `required` attribute on
     radio inputs would also catch this, but the AJAX cart on this
     theme bypasses native form validation in some cases — this
     handler is the explicit safety net.

     For optional groups (Allergy Friendly, Gluten Friendly), no
     blocking — customer can leave them unset.
     ──────────────────────────────────────────────────────────── */
  function findRequiredModifierFieldset(form) {
    if (!form) return null;
    // The fieldset uses `form="<id>"` association rather than nesting.
    // Look up by matching data-product-form-id to the form's id.
    var formId = form.getAttribute('id');
    if (!formId) return null;
    var fieldsets = document.querySelectorAll('.product-modifiers[data-modifier-required="true"][data-product-form-id="' + formId + '"]');
    for (var i = 0; i < fieldsets.length; i++) {
      if (!isModifierFieldsetSatisfied(fieldsets[i])) return fieldsets[i];
    }
    return null;
  }

  function isModifierFieldsetSatisfied(fieldset) {
    // Look for any input inside the fieldset (radios) OR associated by name
    // (in case future groups use selects/textareas). For now, the only
    // required types are radios.
    var radios = fieldset.querySelectorAll('input[type="radio"]');
    if (radios.length > 0) {
      for (var i = 0; i < radios.length; i++) if (radios[i].checked) return true;
      return false;
    }
    // Fallback: assume satisfied if no radios were rendered (other types
    // are optional in our current setup).
    return true;
  }

  function flashModifierError(fieldset) {
    fieldset.classList.add('is-invalid');
    var errorEl = fieldset.querySelector('.product-modifiers__error');
    if (errorEl) errorEl.hidden = false;
    fieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
    // Drop the shake class after the animation finishes so it can re-trigger
    setTimeout(function () { fieldset.classList.remove('is-invalid'); }, 400);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    // Only intercept product Add-to-Cart forms (action contains /cart/add).
    var action = (form.getAttribute('action') || '').toLowerCase();
    if (action.indexOf('/cart/add') === -1) return;
    var unsatisfied = findRequiredModifierFieldset(form);
    if (unsatisfied) {
      e.preventDefault();
      e.stopPropagation();
      flashModifierError(unsatisfied);
    }
  }, true); // capture so we run before the theme's AJAX submit handler

  // Also clear the error display the moment a customer makes a selection
  document.addEventListener('change', function (e) {
    var fieldset = e.target && e.target.closest
      ? e.target.closest('.product-modifiers')
      : null;
    if (!fieldset) return;
    if (isModifierFieldsetSatisfied(fieldset)) {
      var errorEl = fieldset.querySelector('.product-modifiers__error');
      if (errorEl) errorEl.hidden = true;
    }
  }, false);

})();
// modifier-build-bump 1777296651
// modifier-validate-bump 1777298151315270000
